import { getMarkJS } from 'owa-mark/lib/utils/constants';

export default async function highlightTermsInHtmlElement(
    element: HTMLElement,
    highlightTerms: string[],
    separateWordSearch: boolean = false,
    matchPrefix: boolean = false
) {
    if (element) {
        let MarkJS = await getMarkJS();
        let marker = MarkJS.call(MarkJS, element);
        if (highlightTerms) {
            marker.mark(highlightTerms, {
                separateWordSearch: separateWordSearch,
                accuracy: matchPrefix ? 'prefix' : 'partially',
            });
        } else {
            marker.unmark();
        }
    }
}
